import React from 'react';

const ColombiaPage = () => {
  return (
    <div className="page-container-wrapper max-width-default padding-default">
      <div className="page-header">
        <h1>
          <i className="fas fa-flag"></i>
          Colombia - Tierra de Diversidad
        </h1>
        <p>Exploring the vibrant culture and natural beauty of Colombia.</p>
      </div>

      <div className="page-content">
        <div className="section">
          <div className="colombia-content">
            <p className="welcome-text">
              Colombia is a land of incredible diversity - from the snow-capped peaks
              of the Andes to the pristine beaches of the Caribbean coast, from the
              lush Amazon rainforest to the vibrant cities filled with culture and history.
              This beautiful country holds a special place in our hearts.
            </p>

            <div className="colombia-description">
              <h3>About Colombia</h3>
              <p>
                Colombia is a country that captivates with its natural beauty,
                rich cultural heritage, and the warmth of its people. Known for
                its coffee, emeralds, and incredible biodiversity, Colombia offers
                experiences that range from colonial architecture in Cartagena
                to the modern energy of Bogotá and Medellín.
              </p>
            </div>

            <div className="colombia-highlights">
              <h3>Colombian Treasures</h3>
              <div className="highlights-grid">
                <div className="highlight-item">
                  <h4><i className="fas fa-coffee"></i> Café Colombiano</h4>
                  <p>World-renowned coffee grown in the perfect climate of the Coffee Triangle</p>
                </div>
                
                <div className="highlight-item">
                  <h4><i className="fas fa-leaf"></i> Biodiversidad</h4>
                  <p>One of the world's most biodiverse countries with unique ecosystems</p>
                </div>
                
                <div className="highlight-item">
                  <h4><i className="fas fa-music"></i> Cultura Vibrante</h4>
                  <p>Rich musical traditions from cumbia to vallenato and salsa</p>
                </div>
                
                <div className="highlight-item">
                  <h4><i className="fas fa-gem"></i> Esmeraldas</h4>
                  <p>Home to the world's finest emeralds and precious gemstones</p>
                </div>
              </div>
            </div>

            <div className="cultural-appreciation">
              <h3>Colombian Spirit</h3>
              <p>
                What makes Colombia truly special is the spirit of its people -
                their resilience, warmth, and zest for life. Colombians have a
                unique ability to find joy in simple moments and to welcome
                others with open arms and generous hearts.
              </p>
              
              <p>
                The Colombian concept of "ganas" - the enthusiasm and positive
                attitude toward life - is something that resonates deeply.
                It's about approaching each day with energy, optimism, and
                a willingness to embrace whatever comes your way.
              </p>
            </div>

            <div className="personal-connection">
              <h3>Our Connection to Colombia</h3>
              <p>
                Colombia represents adventure, discovery, and the beauty of
                experiencing different cultures. Whether it's through the people
                we've met, the places we've visited, or the lessons we've learned,
                Colombia has enriched our understanding of the world and reminded
                us of the importance of embracing diversity and celebrating
                different ways of life.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ColombiaPage;